export default __webpack_public_path__ + "static/media/new_interpretazione_attiva.406ebe70.jpeg";